export default __webpack_public_path__ + "static/media/Group 70.eb443961.svg";